import { makeStyles, createStyles } from "@material-ui/core";
import { Colors } from "../../styles";

export const useStyles = makeStyles(() =>
    createStyles({
        header: {
            fontFamily: "innogyWEB",
            fontSize: 37,
            fontWeight: 500,

            color: Colors.anthracite,
        },
        section: {
            marginTop: 24,
            padding: 24,
            fontFamily: "innogyWEB",
            display: "flex",
            flexDirection: "column",
        },
        sectionTitleContainer: {
            margin: 0,
            padding: 0,
            display: "flex",
            flexDirection: "row",
        },
        sectionTitle: {
            fontSize: 25,
            fontWeight: 500,
            lineHeight: 1.28,
            color: Colors.anthracite,
        },
        groupContainer: {
            marginTop: 16,
            marginBottom: 16,
            padding: 0,
            fontSize: 22,
            display: "flex",
            flexDirection: "column",
        },
        groupTitle: {
            fontWeight: 500,
            lineHeight: 1.45,
            color: Colors.anthracite,
        },
        summaryTwoColumnContainer: {
            marginTop: 12,
            fontWeight: 300,
            lineHeight: 1.27,
            display: "flex",
            flexDirection: "row",
        },
        summaryTwoColumnTitle: {
            flex: 0.55,
        },
        summaryTwoColumnValue: {
            flex: 0.45,
        },
        summaryThreeColumnContainer: {
            marginTop: 12,
            fontWeight: 300,
            lineHeight: 1.27,
            display: "flex",
            flexDirection: "row",
        },
        summaryThreeColumnTitle: {
            flex: 0.55,
        },
        summaryThreeColumnValueOne: {
            flex: 0.2,
            overflowWrap: "anywhere",
        },
        summaryThreeColumnValueTwo: {
            flex: 0.25,
        },
        summaryError: {
            color: Colors.radiantRed,
        },
        text: {
            fontSize: 22,
            fontWeight: 300,

            color: Colors.anthracite,
        },
        editIcon: {
            alignSelf: "flex-end",
        },
        documentsHeaderContainer: {
            marginTop: 16,
            marginBottom: 16,
            padding: 0,
            fontSize: 22,
            display: "flex",
            flexDirection: "row",
        },
        documentsHeaderFile: {
            fontWeight: 500,
            lineHeight: 1.45,
            color: Colors.anthracite,
            flex: 0.65,
        },
        documentsHeaderTimestamp: {
            fontWeight: 500,
            lineHeight: 1.45,
            color: Colors.anthracite,
            flex: 0.35,
        },
        missingDocumentsHeader: {
            fontWeight: 500,
            lineHeight: 1.45,
            color: Colors.anthracite,
            marginTop: 16,
            fontSize: 22,
        },
        missingDocumentsList: {
            color: Colors.radiantRed,
            marginTop: 12,
            fontSize: 22,
            fontWeight: 300,
        },
        documentsContainer: {
            marginTop: 16,
            padding: 0,
            fontSize: 22,
            fontWeight: 200,
            lineHeight: 1.27,
            display: "flex",
            flexDirection: "row",
            gap: "12px",
        },
        documentsFile: {
            display: "flex",
            minHeight: 32,
            color: Colors.anthracite,
            flex: 0.65,
            wordBreak: "break-word",
        },
        documentsTimestamp: {
            height: 32,
            color: Colors.anthracite,
            flex: 0.35,
        },
        icon: {
            width: 30,
            height: 30,
            objectFit: "contain",
        },
        additionalInfoTitle: {
            fontFamily: "innogyWEB",
            fontWeight: 500,
            lineHeight: 1.28,
            color: Colors.anthracite,
            marginTop: 38,
            marginBottom: 18,
            fontSize: 25,
        },
        addressContainer: {
            marginTop: 12,
            padding: 0,
            fontSize: 22,
            fontWeight: 200,
            lineHeight: 1.27,
            display: "flex",
            flexDirection: "row",
            cursor: "pointer",
        },
        addressLabel: {
            color: Colors.anthracite,
            flex: 0.3,
        },
        addressValue: {
            color: Colors.anthracite,
            flex: 0.7,
        },
        addressError: {
            color: Colors.radiantRed,
        },
    }),
);
